export const OTHER_CODE  = 999991;
export const TOTAL_CODE  = 999992;


// WEBPACK FOOTER //
// ./src/configs/index.js